import { createIcon } from '../createIcon';

export const CircleIcon = createIcon({
  viewBox: '0 0 24 24',
  d: 'M 12, 12 m -9, 0 a 9,9 0 1,0 18,0 a 9,9 0 1,0 -18,0',
});
